/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Tab_PromosInputs */



/**
* | output |
* | --- |
* | "Promos" |
*
* @param {Community_Tab_PromosInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_tab_promos = /** @type {((inputs?: Community_Tab_PromosInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Tab_PromosInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Promos")
	if (locale === "es") return /** @type {LocalizedString} */ ("Promos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Promos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Promo")
	return /** @type {LocalizedString} */ ("Promos")
});